import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=98c5f300&scoped=true&lang=pug"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=98c5f300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c5f300",
  null
  
)

export default component.exports